import { DatePicker } from "antd";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";

type Props = {
  value?: Date;
  onChange?: (date: Date) => void;
};

/**
 * DatePicker that converts a dayjs date to a js Date object and vice versa.
 */
export const DatePickerPlain = observer((props: Props) => {
  const [value, setValue] = useState<Date | undefined>(props.value);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  useEffect(() => {
    props.onChange?.(value);
  }, [value]);

  return (
    <DatePicker
      value={dayjs(value)}
      onChange={(date) => setValue(date.toDate())}
    />
  );
});
